import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import light from './light';
import './scss/main.scss';
import './scss/preset.scss';
import i18n from '@/plugins/i18n';
import { aliases, mdi } from 'vuetify/iconsets/mdi';

const options = {
  icons: {
    defaultSet: 'mdi',
    aliases: {
      ...aliases,
      success: "mdi-check-circle-outline",
      info: "mdi-information-outline",
      warning: "mdi-alert-circle-outline",
      error: "mdi-alert-outline"
    },
    sets: {
      mdi
    }
  },
  theme: {
    options: { customProperties: true },
    defaultTheme: "light",
    themes: {
      light
    }
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  }
};

export default createVuetify(options);
